'use client';
import type { LinkShape } from '../../Anchor';
import { CardProps } from '../../Card';
import { Text } from '../../Text';
import { Brands } from '../../Theme';
import { SanityImage } from '../../types';
import { menuItemStyles } from './NavLinkMobile';

export type NavItemProps = {
	title?: string;
	description?: string;
	image?: SanityImage;
	href?: string;
	brand?: Brands;
};

export type NavGroupProps = {
	label?: string;
	cards?: NavItemProps[];
	items?: NavItemProps[];
	brand?: Brands;
};

export type NavDropdownProps = {
	item: LinkShape;
	groups?: NavGroupProps[];
	featuredCards?: CardProps[];
};

export function NavDropdownMobile(
	navItem: NavDropdownProps & {
		activeTab: number | undefined;
		setActiveTab(value: number | undefined): void;
		index: number;
	},
) {
	const { link } = menuItemStyles({ active: navItem.activeTab === navItem.index });

	return (
		<div
			className={link()}
			onClick={e => {
				if (navItem.activeTab === navItem.index) {
					navItem.setActiveTab(undefined);
				} else {
					navItem.setActiveTab(navItem.index);
				}
			}}
		>
			<Text styleType='button-md'>{navItem.item.label}</Text>
		</div>
	);
}

/**
 * Calculates the left offset of the given HTML element
 * @param element The HTML element to calculate the left offset for
 * @returns The left offset of the element
 */
export function getLeftCentreButtonOffset(element: HTMLElement | null) {
	if (!element) {
		return { center: 0, navWidth: 0 };
	}

	const width = element.clientWidth / 2;

	let navWidth = 0;
	let coords = 0;
	while (element) {
		const navElement = element.offsetParent?.querySelector('[data-component="Nav"]');
		if (!navElement) {
			coords += element.offsetLeft;
			element = element.offsetParent as HTMLElement;
		} else {
			element = null;
			navWidth = navElement.clientWidth;
		}
	}
	return { center: coords + width, navWidth };
}
